var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper" },
    [
      _vm.sidebarType === 1
        ? _c("el-container", [_c("MenuSingleLayer")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.sidebarType === 2
        ? _c("el-container", [_c("MenuDoubleLayer")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }